import { RouteType } from "types/RouteType";

// Month/week calendar of all loads across projects by ship date, so shipping
// can spot same-destination loads ("fill the Nashville truck") and avoid
// double-scheduling. Data loads via MMLoadStore / MMProjectStore, which
// self-load on sign-in (same pattern as the Loads route).
const shippingCalendarRoute: RouteType = {
  name: "MM Shipping Calendar",
  path: "/mm/shipping-calendar",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Shipping Calendar",
      component: () => import("./ShippingCalendar.Header"),
      enableRefreshButton: false,
      enableBackButton: false,
    },
    body: {
      component: () => import("./ShippingCalendar.Body"),
      grayBackground: true,
    },
  },
  group: "Miller-Mize",
  menuOrder: 6,
  requiresAuth: true,
  requiresPermission: false,
};

export default shippingCalendarRoute;
